import React from 'react';
import axios from 'axios';

export default function DeleteClientModal({ client, onClose, onUpdateScreen }) {
    const handleDelete = async () => {
        try {
            await axios.delete(`${process.env.REACT_APP_API_URL || "https://api.clelton-churrasqueiras.site"}/clientRoutes/clientes/${client.id}`);
            onUpdateScreen(); // Atualiza a tela após a exclusão
            onClose(); // Fecha o modal
        } catch (error) {
            console.error('Error deleting client:', error);
        }
    };

    if (!client) {
        return null; // Evita renderizar se nenhum cliente foi selecionado
    }

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center">
            <div className="glass-panel p-6 w-full max-w-2xl text-white max-w-md">
                <h2 className="text-xl font-bold text-white mb-6 tracking-wide">Excluir Cliente</h2>
                <p>Tem certeza que deseja excluir o cliente <strong>{client.nome}</strong>?</p>
                <div className="flex justify-end mt-6 space-x-4">
                    <button
                        onClick={onClose}
                        className="bg-gray-300 hover:bg-gray-400 text-white py-2 px-4 rounded-md"
                    >
                        Cancelar
                    </button>
                    <button
                        onClick={handleDelete}
                        className="bg-red-500 hover:bg-red-600 text-white py-2 px-4 rounded-md"
                    >
                        Excluir
                    </button>
                </div>
            </div>
        </div>
    );
}
